export const oldDemoPages = [
  'http://demos.rezonence.com/publishers/Rezonence-PublisherBlog-ZC.html',
  'https://blog.rezonence.com/all/demo-article-to-see-a-freewall-in-action'
];
